import { NgModule } from '@angular/core';
import { MODALS } from './modal/modal.config';

@NgModule({
  providers: [
    {
      provide: MODALS,
      useValue: () => import('./ui-modal-routes').then(m => m.uiModals),
      multi: true,
    },
  ],
})
export class UiModalsModule {}
